module.exports = __webpack_public_path__ + "static/dons-outils-libres-2020-dd6fac96cd4f1303b3f7ad6146baa0e1.jpg";